<!-- Estilos CSS para el modal más grande -->
<style>
::ng-deep .custom-offcanvas-lg {
  width: 500px !important;
  max-width: 90vw !important;
}

@media (max-width: 768px) {
  ::ng-deep .custom-offcanvas-lg {
    width: 100vw !important;
  }
}
</style>

<ng-template #pocision let-offcanvas>
    <div class="offcanvas-header border-b border-gray-200">
        <div class="w-full">
            <div class="flex items-center justify-between">
                <div class="flex-1">
                    <h4 class="text-xl font-semibold text-gray-900">
                        Consulta cupo
                    </h4>
                </div>
                <button type="button" class="text-gray-400 hover:text-gray-600 p-2" (click)="offcanvas.dismiss()">
                    <i class="fas fa-times text-xl"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="offcanvas-body p-0">
        <div class="h-full overflow-y-auto">
            <div class="p-6 space-y-6">
                <ng-container *ngIf="searchPerson">
                    <!-- Profile Info Card -->
                    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div class="flex items-center gap-4">
                            <div class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 flex-shrink-0">
                                <!-- When no selfie available -->
                                <img *ngIf="!searchPerson?.file_selfie && searchPerson?.gender != 'F'"
                                     class="w-full h-full object-cover"
                                     [src]="sanitize('../assets/public/images/avatar.png')">
                                <img *ngIf="!searchPerson?.file_selfie && searchPerson?.gender == 'F'"
                                     class="w-full h-full object-cover"
                                     [src]="sanitize('../assets/public/images/avatara-female.png')">

                                <!-- When selfie is available -->
                                <img *ngIf="searchPerson?.file_selfie"
                                     class="w-full h-full object-cover"
                                     [src]="sanitize(searchPerson?.file_selfie?.url)">
                            </div>
                            <div class="flex-1 min-w-0">
                                <div class="text-lg font-semibold text-gray-900 truncate">{{searchPerson?.name}} {{searchPerson?.lastName}}</div>
                                
                                <!-- Badge de Reactivación por Penalidad -->
                                <div *ngIf="searchPerson?.penalty_reactivation_count > 0" 
                                     class="inline-flex items-center gap-1.5 mt-1.5 px-2.5 py-1 text-xs rounded-md bg-amber-50 text-amber-700 border border-amber-200"
                                     [title]="'Reactivado ' + searchPerson?.penalty_reactivation_count + ' veces por penalidad'">
                                    <i class="fas fa-redo text-amber-500 text-[10px]"></i>
                                    <span class="font-normal">Reactivado por penalidad</span>
                                    <span class="ml-0.5 px-2 py-0.5 text-xs font-bold rounded-full bg-amber-600 text-white shadow-sm">
                                        {{searchPerson?.penalty_reactivation_count}}×
                                    </span>
                                </div>
                                <div class="flex items-center gap-2 text-sm text-gray-600 mt-1">
                                    <i class="fas fa-id-card text-blue-600"></i>
                                    <span class="cursor-pointer hover:text-blue-600 transition-colors ml-1"
                                          (click)="copyIdentityToClipboard(searchPerson)"
                                          title="Clic para copiar">{{identityResponse}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Quota Info Card -->
                    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div class="space-y-4">
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <div class="text-sm text-gray-600 mb-1">Cupo asignado</div>
                                    <div class="text-xl font-bold text-gray-900">
                                        {{searchPerson?.current_quota | currency:'USD':'': '1.2-2'}} USD
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div class="text-sm text-gray-600 mb-1">Disponible</div>
                                    <div class="text-xl font-semibold text-gray-900">
                                        {{searchPerson?.quota | currency:'USD':'': '1.2-2'}} USD
                                    </div>
                                </div>
                            </div>

                            <div class="text-right" *ngIf="person?.person?.quota_active && (_auth.hasPermission('cupo.consultar_cupo.update') || _auth.hasPermission('contactos.cupo.update'))">
                                <button class="text-blue-600 hover:text-blue-800 cursor-pointer"
                                        (click)="edit_quote = !edit_quote"
                                        *ngIf="!edit_quote">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>
                                <button class="text-blue-600 hover:text-blue-800 cursor-pointer"
                                        (click)="edit_quote = !edit_quote"
                                        *ngIf="edit_quote">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>

                            <div *ngIf="edit_quote && person?.person?.quota_active" class="border-t pt-4">
                                <div class="space-y-3">
                                    <div>
                                        <input type="number"
                                               [(ngModel)]="new_quote"
                                               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                               placeholder="Nuevo Cupo">
                                    </div>
                                    <button (click)="change_quote()"
                                            [disabled]="!new_quote || submit_disabled_quote"
                                            class="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
                                        Cambiar
                                        <span *ngIf="submit_disabled_quote">
                                            <i class="fa fa-spinner fa-spin ml-2"></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Status Control Card -->
                    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['cupo.estatus_cupo.read', 'contactos.cupo.config'])">
                        <div class="space-y-4">
                            <!-- Header unificado: título + (Activo/Inactivo) azul + toggle si OWNER -->
                            <div class="flex justify-between items-center">
                                <div class="font-medium text-gray-900">
                                    Estatus del cupo
                                </div>
                                <div class="flex items-center gap-3">
                                    <div class="text-blue-600 font-medium">
                                        ({{person?.person?.quota_active ? "Activo" : "Inactivo"}})
                                    </div>
                                    <ng-toggle *ngIf="_auth.hasAccessOrProfile('contactos', ['OWNER'])"
                                               (change)="toogleStatus()"
                                               [(ngModel)]="usQuote"
                                               [value]="true"
                                               [disabled]="_auth.hasRbac$.getValue() && !_auth.hasPermission('cupo.estatus_cupo.update')"
                                               [color]="{
                                                   checked: '#01abce',
                                                   unchecked: '#dcdcdc'
                                               }"></ng-toggle>
                                </div>
                            </div>

                            <div *ngIf="person?.person?.automatic_description_status" class="pt-3 border-t">
                                <div class="text-sm text-gray-600">
                                    {{person?.person?.automatic_description_status}}
                                </div>
                            </div>

                            <div *ngIf="person?.person?.ejecutive_change_status_date_quota" class="pt-3 border-t">
                                <div class="space-y-3">
                                    <div>
                                        <div class="text-sm text-gray-600 mb-1">Última actualización</div>
                                        <div class="text-sm text-gray-900">
                                            {{person?.person?.ejecutive_change_status_date_quota | date: 'dd/MM/yyyy h:mm:ss a'}}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-sm text-gray-600 mb-1">Responsable</div>
                                        <div class="text-sm text-gray-900">
                                            {{person?.person?.ejecutive_change_status_quota.name}} {{person?.person?.ejecutive_change_status_quota.lastName}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="person?.person?.user_blocked_manually_option" class="pt-3 border-t">
                                <div class="flex items-start gap-2">
                                    <i class="fas fa-info-circle text-orange-500 mt-0.5"></i>
                                    <div class="flex-1">
                                        <div class="text-xs font-semibold text-gray-600 uppercase mb-1">Motivo de inactivación</div>
                                        <div class="text-sm text-gray-900 font-medium">
                                            {{reasons[person?.person?.user_blocked_manually_option]}}
                                        </div>
                                        <div *ngIf="person?.quota_status_message"
                                             class="mt-2 text-xs text-gray-600 italic bg-gray-50 border border-gray-200 rounded px-2 py-1">
                                            "{{ person?.quota_status_message }}"
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="person?.person?.automatic && !person?.person?.ejecutive_change_status_date_quota" class="pt-3 border-t">
                                <div class="space-y-3">
                                    <div *ngIf="person?.person?.automatic_change_status_date_quota">
                                        <div class="text-sm text-gray-600 mb-1">Última actualización</div>
                                        <div class="text-sm text-gray-900">
                                            {{person?.person?.automatic_change_status_date_quota | date: 'dd/MM/yyyy h:mm:ss a'}}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-sm text-gray-600 mb-1">Responsable</div>
                                        <div class="text-sm text-gray-900">Automático</div>
                                    </div>
                                    <div *ngIf="person?.quota_status_message"
                                         class="mt-2 text-xs text-gray-600 italic bg-gray-50 border border-gray-200 rounded px-2 py-1">
                                        "{{ person?.quota_status_message }}"
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="person?.person?.params?.status_quota?.current?.description" class="pt-3 border-t">
                                <div class="text-sm text-gray-600 mb-1">Comentario:</div>
                                <div class="text-sm text-gray-900">
                                    {{person?.person?.params?.status_quota?.current?.description}}
                                </div>
                            </div>

                            <div *ngIf="person?.person?.payment_fee" class="pt-3 border-t">
                                <div class="text-sm text-gray-600 mb-1">Pago de reactivación</div>
                                <div class="text-sm text-blue-600 cursor-pointer hover:text-blue-800"
                                     (click)="openBottom(payment, {person_code: person?.person?.code, code_payment: person?.person?.payment_fee?.code})">
                                    {{person?.person?.payment_fee?.code}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Client Status Card -->
                    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['cupo.cupo_habilitado.read', 'contactos.cupo.config'])">
                        <div class="space-y-4">
                            <!-- Header unificado: título + (Sí/No) azul + toggle si OWNER -->
                            <div class="flex justify-between items-center">
                                <div class="font-medium text-gray-900">
                                    Cupo habilitado por el cliente
                                </div>
                                <div class="flex items-center gap-3">
                                    <div class="text-blue-600 font-medium">
                                        ({{person?.person?.quota_client_active ? "Sí" : "No"}})
                                    </div>
                                    <ng-toggle *ngIf="_auth.hasAccessOrProfile('contactos', ['OWNER'])"
                                               (change)="toogleStatusClient()"
                                               [(ngModel)]="usQuoteClien"
                                               [value]="true"
                                               [disabled]="_auth.hasRbac$.getValue() && !_auth.hasPermission('cupo.cupo_habilitado.update')"
                                               [color]="{
                                                   checked: '#01abce',
                                                   unchecked: '#dcdcdc'
                                               }"></ng-toggle>
                                </div>
                            </div>

                            <div *ngIf="person?.person?.automatic_description_status" class="pt-3 border-t">
                                <div class="text-sm text-gray-600">
                                    {{person?.person?.automatic_description_status}}
                                </div>
                            </div>

                            <div *ngIf="person?.person?.ejecutive_quota_client_active" class="pt-3 border-t">
                                <div class="space-y-3">
                                    <div>
                                        <div class="text-sm text-gray-600 mb-1">Última actualización</div>
                                        <div class="text-sm text-gray-900">
                                            {{person?.person?.date_quota_client_active | date: 'dd/MM/yyyy h:mm:ss a'}}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-sm text-gray-600 mb-1">Responsable</div>
                                        <div class="text-sm text-gray-900">
                                            {{person?.person?.ejecutive_quota_client_active.name}} {{person?.person?.ejecutive_quota_client_active.lastName}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="person?.payment_fee?.code" class="pt-3 border-t">
                                <div class="text-sm text-gray-600 mb-1">Payment</div>
                                <div class="text-sm text-gray-900">
                                    {{person?.payment_fee?.code}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ============================================ -->
                    <!-- HISTORIAL DE CAMBIOS DE CUPO -->
                    <!-- ============================================ -->
                    <div class="bg-white rounded-lg shadow-sm border border-gray-200" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['cupo.historial_cambios_cupo.read', 'contactos.cupo.config'])">
                        <div class="p-4 border-b border-gray-200">
                            <button (click)="toggleHistorySection()" 
                                    class="w-full flex items-center justify-between text-left">
                                <div class="flex items-center gap-3">
                                    <i class="fas fa-history text-blue-600 text-lg"></i>
                                    <div>
                                        <div class="font-semibold text-gray-900">Historial de Cambios de Cupo</div>
                                        <div class="text-sm text-gray-600">Ver todos los cambios realizados</div>
                                    </div>
                                </div>
                                <i class="fas" [ngClass]="showHistorySection ? 'fa-chevron-up' : 'fa-chevron-down'" 
                                   class="text-gray-400"></i>
                            </button>
                        </div>

                        <div *ngIf="showHistorySection" class="p-4 space-y-4">
                            <!-- Filtros -->
                            <div class="bg-gray-50 rounded-lg p-4 space-y-3">
                                <div class="font-medium text-gray-900 text-sm mb-3">
                                    <i class="fas fa-filter text-blue-600 mr-2"></i>Filtros
                                </div>
                                
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div>
                                        <label class="block text-xs font-medium text-gray-700 mb-1">Fecha Inicio</label>
                                        <!-- Mobile -->
                                        <div class="md:hidden">
                                            <mbsc-date 
                                                [(ngModel)]="dateRangeStart"
                                                [options]="mobileDateSettings"
                                                placeholder="Seleccione fecha inicio">
                                            </mbsc-date>
                                        </div>
                                        <!-- Desktop -->
                                        <div class="hidden md:block">
                                            <mbsc-date 
                                                [(ngModel)]="dateRangeStart"
                                                [options]="desktopDateSettings"
                                                placeholder="Seleccione fecha inicio">
                                            </mbsc-date>
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-xs font-medium text-gray-700 mb-1">Fecha Fin</label>
                                        <!-- Mobile -->
                                        <div class="md:hidden">
                                            <mbsc-date 
                                                [(ngModel)]="dateRangeEnd"
                                                [options]="mobileDateSettings"
                                                placeholder="Seleccione fecha fin">
                                            </mbsc-date>
                                        </div>
                                        <!-- Desktop -->
                                        <div class="hidden md:block">
                                            <mbsc-date 
                                                [(ngModel)]="dateRangeEnd"
                                                [options]="desktopDateSettings"
                                                placeholder="Seleccione fecha fin">
                                            </mbsc-date>
                                        </div>
                                    </div>
                                </div>
                                
                                <div>
                                    <label class="block text-xs font-medium text-gray-700 mb-1">Ejecutivo</label>
                                    <input type="text" 
                                           [(ngModel)]="historyFilters.nombreEjecutivo" 
                                           placeholder="Buscar por nombre o apellido"
                                           class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                                </div>
                                
                                <div class="flex gap-2 pt-2">
                                    <button (click)="applyHistoryFilters()" 
                                            class="flex-1 px-4 py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors">
                                        <i class="fas fa-search mr-2"></i>Buscar
                                    </button>
                                    <button (click)="clearHistoryFilters()" 
                                            class="px-4 py-2 bg-gray-200 text-gray-700 text-sm rounded-md hover:bg-gray-300 transition-colors">
                                        <i class="fas fa-times mr-2"></i>Limpiar
                                    </button>
                                </div>
                            </div>

                            <!-- Loading State -->
                            <div *ngIf="loadingHistory" class="text-center py-8">
                                <i class="fas fa-spinner fa-spin text-3xl text-blue-600"></i>
                                <div class="text-sm text-gray-600 mt-2">Cargando historial...</div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="!loadingHistory && quotaHistory.length === 0" class="text-center py-8">
                                <i class="fas fa-inbox text-4xl text-gray-300 mb-3"></i>
                                <div class="text-sm text-gray-600">No se encontraron cambios de cupo</div>
                            </div>

                            <!-- History Table -->
                            <div *ngIf="!loadingHistory && quotaHistory.length > 0" class="space-y-3">
                                <div *ngFor="let item of quotaHistory" 
                                     class="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow bg-gray-50">
                                    <div class="mb-3">
                                        <div class="flex items-center gap-2 mb-1">
                                            <i class="fas fa-calendar-alt text-blue-600 text-sm"></i>
                                            <span class="font-semibold text-gray-900 text-sm">{{item.fechaCambio}}</span>
                                            <span class="text-gray-500 text-xs" *ngIf="item.horaCambio">• {{item.horaCambio}}</span>
                                        </div>
                                        <div class="flex items-center gap-2 text-xs text-gray-600">
                                            <i class="fas fa-user text-gray-400"></i>
                                            <span>{{item.ejecutivo || 'Sin ejecutivo'}}</span>
                                        </div>
                                    </div>

                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-3 border-t border-gray-100">
                                        <!-- Cupo Asignado -->
                                        <div class="bg-white rounded-md border border-gray-200 p-3">
                                            <div class="text-xs text-gray-600 mb-2 font-medium">Cupo Asignado</div>
                                            <div class="flex items-center gap-2">
                                                <div class="flex-1">
                                                    <div class="text-xs text-gray-500">Antes</div>
                                                    <div class="text-sm font-semibold text-gray-700">
                                                        ${{item.currentQuotaAntigua | number:'1.2-2'}}
                                                    </div>
                                                </div>
                                                <i [ngClass]="getQuotaChangeIcon(item.currentQuotaAntigua, item.currentQuotaNueva)"
                                                   class="text-lg" [class]="getQuotaChangeClass(item.currentQuotaAntigua, item.currentQuotaNueva)"></i>
                                                <div class="flex-1">
                                                    <div class="text-xs text-gray-500">Después</div>
                                                    <div class="text-sm font-bold" 
                                                         [class]="getQuotaChangeClass(item.currentQuotaAntigua, item.currentQuotaNueva)">
                                                        ${{item.currentQuotaNueva | number:'1.2-2'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Cupo Disponible -->
                                        <div class="bg-white rounded-md border border-gray-200 p-3">
                                            <div class="text-xs text-gray-600 mb-2 font-medium">Cupo Disponible</div>
                                            <div class="flex items-center gap-2">
                                                <div class="flex-1">
                                                    <div class="text-xs text-gray-500">Antes</div>
                                                    <div class="text-sm font-semibold text-gray-700">
                                                        ${{item.quotaAntigua | number:'1.2-2'}}
                                                    </div>
                                                </div>
                                                <i [ngClass]="getQuotaChangeIcon(item.quotaAntigua, item.quotaNueva)"
                                                   class="text-lg" [class]="getQuotaChangeClass(item.quotaAntigua, item.quotaNueva)"></i>
                                                <div class="flex-1">
                                                    <div class="text-xs text-gray-500">Después</div>
                                                    <div class="text-sm font-bold" 
                                                         [class]="getQuotaChangeClass(item.quotaAntigua, item.quotaNueva)">
                                                        ${{item.quotaNueva | number:'1.2-2'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex gap-4 pt-3 border-t border-gray-100 mt-3">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-600">Monto Ajuste</div>
                                            <div class="text-sm font-medium text-gray-900">
                                                ${{item.montoAjuste | number:'1.2-2'}}
                                            </div>
                                        </div>
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-600">Canal</div>
                                            <div class="text-sm font-medium text-gray-900">
                                                {{item.canal || '—'}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pagination -->
                                <div *ngIf="historyTotalPages > 1" class="flex justify-center items-center gap-2 pt-4">
                                    <button (click)="changeHistoryPage(historyPage - 1)" 
                                            [disabled]="historyPage === 1"
                                            class="px-3 py-1 bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300">
                                        <i class="fas fa-chevron-left"></i>
                                    </button>
                                    
                                    <span class="text-sm text-gray-700">
                                        Página {{historyPage}} de {{historyTotalPages}} ({{historyTotal}} registros)
                                    </span>
                                    
                                    <button (click)="changeHistoryPage(historyPage + 1)" 
                                            [disabled]="historyPage === historyTotalPages"
                                            class="px-3 py-1 bg-gray-200 text-gray-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300">
                                        <i class="fas fa-chevron-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

<!-- Sección principal refactorizada con Tailwind CSS -->
<div class="min-h-screen bg-gray-50 py-8">
    <div class="max-w-6xl mx-auto px-4">
        <!-- Header -->
        <div class="text-center mb-8">
            <h1 class="text-3xl font-bold text-gray-900 mb-2 flex items-center justify-center gap-3">
                <i class="fas fa-user text-blue-600"></i>
                Perfil de Cliente
                <!-- Burbuja del header removida (Ajuste 06): el estado se muestra ahora en el bloque consolidado -->
            </h1>
        </div>

        <!-- Banner: Penalidad de persona pendiente para reactivación (solo si cliente inactivo) -->
        <div *ngIf="hasPendingPersonFees && !person?.person?.quota_active" class="mb-4">
            <div class="alert alert-warning d-flex align-items-center justify-content-between mb-0">
                <div>
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    Tiene una penalidad pendiente por
                    <strong>{{ pendingPersonDueTotal | currency:'USD':'': '1.2-2' }} USD</strong>
                    para reactivarse.
                </div>
                <button class="btn btn-sm btn-primary" (click)="goToPayPendingPersonFees()">
                    Pagar ahora
                </button>
            </div>
        </div>

        <!-- Profile Info Card -->
        <div *ngIf="!loading && person?.person" class="bg-white rounded-lg p-4 mb-4 shadow-sm border border-gray-200">
            <div class="flex items-start gap-3">
                <!-- Avatar Section -->
                <div class="flex-shrink-0">
                    <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                         *ngIf="!person?.person?.file_selfie"
                         class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 cursor-pointer hover:scale-105 transition-transform duration-200">
                        <img *ngIf="person?.person.gender != 'F'"
                             class="w-full h-full object-cover"
                             [src]="sanitize('../assets/public/images/avatar.png')">
                        <img *ngIf="person?.person.gender == 'F'"
                             class="w-full h-full object-cover"
                             [src]="sanitize('../assets/public/images/avatara-female.png')">
                    </div>

                    <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                         *ngIf="person?.person?.file_selfie"
                         class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 cursor-pointer hover:scale-105 transition-transform duration-200">
                        <img class="w-full h-full object-cover"
                             [src]="sanitize(person?.person?.file_selfie?.url)">
                    </div>
                </div>

                <!-- Info Section -->
                <div class="flex-1">
                    <h2 class="text-lg font-bold text-gray-900 mb-1">
                        {{person?.person?.name}} {{person?.person?.lastName}}
                    </h2>
                    
                    <!-- Badge de Reactivación por Penalidad -->
                    <div *ngIf="person?.person?.penalty_reactivation_count > 0" 
                         class="inline-flex items-center gap-1.5 mb-2 px-2.5 py-0.5 text-xs rounded-md bg-amber-50 text-amber-700 border border-amber-200"
                         [title]="'Reactivado ' + person?.person?.penalty_reactivation_count + ' veces por penalidad'">
                        <i class="fas fa-redo text-amber-500 text-[10px]"></i>
                        <span class="font-normal">Reactivado por penalidad</span>
                        <span class="ml-0.5 px-2 py-0.5 text-xs font-bold rounded-full bg-amber-600 text-white shadow-sm">
                            {{person?.person?.penalty_reactivation_count}}×
                        </span>
                    </div>

                    <div class="flex flex-wrap gap-x-4 gap-y-1 mb-2 text-sm text-gray-600">
                        <div class="flex items-center gap-1">
                            <i class="fas fa-id-card text-blue-600"></i>
                            <span class="cursor-pointer hover:text-blue-600 transition-colors"
                                  (click)="copyIdentityToClipboard(person)"
                                  title="Clic para copiar">{{getIdentity(person)}}</span>
                        </div>
                        <div class="flex items-center gap-1">
                            <i class="fas fa-phone text-blue-600"></i>
                            <span class="cursor-pointer hover:text-blue-600 transition-colors"
                                  (click)="copyPhoneToClipboard(person)"
                                  title="Clic para copiar">{{getContact(person)}}</span>
                        </div>
                        <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                            <i class="fas fa-envelope text-blue-600"></i>
                            <span>{{getEmailContact(person)}}</span>
                        </div>
                    </div>

                    <!-- 📱 Canal / versión de la app del cliente.
                         Se muestra SOLO si el cliente usa la app nueva (Flutter).
                         La versión aparece únicamente cuando el build la reporta
                         (X-App-Version); si no, se muestra sólo "App nueva". -->
                    <div *ngIf="person?.app_channel?.uses_new_app || person?.app_channel?.app_version"
                         class="mb-2">
                        <span class="inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs rounded-md bg-indigo-50 text-indigo-700 border border-indigo-200"
                              [title]="person?.app_channel?.app_version_updated_at ? ('Versión detectada el ' + (person?.app_channel?.app_version_updated_at | date:'dd/MM/yyyy HH:mm')) : 'Cliente en la app nueva'">
                            <i class="fas fa-mobile-alt text-indigo-500 text-[11px]"></i>
                            <span class="font-semibold">App nueva</span>
                            <span *ngIf="person?.app_channel?.app_version"
                                  class="ml-0.5 px-1.5 py-0.5 text-[11px] font-bold rounded bg-indigo-600 text-white">
                                v{{person?.app_channel?.app_version}}
                            </span>
                        </span>
                    </div>

                    <!-- 🔴 Cartera castigada (Pérdidas Incobrables). Sale de person.cartera
                         (el envelope del perfil). Solo se muestra si el cliente está marcado.
                         - Solo incobrable            -> "Pérdida Incobrable" (rojo)
                         - Mixto (tiene cartera activa) -> "Posible Pérdida" (ámbar) -->
                    <div *ngIf="person?.cartera?.label" class="mb-2">
                        <span class="inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs rounded-md border font-semibold"
                              [ngClass]="person?.cartera?.tiene_cartera_activa
                                  ? 'bg-amber-50 text-amber-800 border-amber-200'
                                  : 'bg-red-50 text-red-700 border-red-200'"
                              [title]="person?.cartera?.tiene_cartera_activa
                                  ? 'Cliente con deuda castigada y también cartera activa'
                                  : 'Cliente con deuda de pérdida incobrable'">
                            <i class="fas fa-circle-exclamation text-[11px]"
                               [ngClass]="person?.cartera?.tiene_cartera_activa ? 'text-amber-600' : 'text-red-500'"></i>
                            <span>{{person?.cartera?.label}}</span>
                        </span>
                    </div>

                    <!-- ════════════════════════════════════════════════════════════ -->
                    <!-- Bloque consolidado de crédito (Ajuste 06, Opción B)          -->
                    <!-- 3 líneas: estado · KPIs · histórico+CTA                       -->
                    <!-- ════════════════════════════════════════════════════════════ -->
                    <div class="border border-gray-200 rounded-md bg-white p-2 text-sm">
                        <!-- LÍNEA 1: estado del cupo (derecha) ------------------------ -->
                        <div class="flex items-center justify-between border-b border-gray-100 pb-1.5 mb-1.5">
                            <!-- Pill mora actual / al día (izquierda) -->
                            <ng-container *ngIf="person?.resumen?.dias_morosidad_sin_historico > 0">
                                <span *ngIf="person?.resumen?.dias_morosidad_sin_historico <= 45"
                                      class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-yellow-100 text-yellow-800 border border-yellow-300">
                                    <i class="fas fa-circle-exclamation text-yellow-600"></i>
                                    {{person?.resumen?.dias_morosidad_sin_historico}}d en mora ·
                                    <ng-container *ngIf="person?.resumen?.cuotas_morosas_count > 0">{{person?.resumen?.cuotas_morosas_count}} cuota{{person?.resumen?.cuotas_morosas_count > 1 ? 's' : ''}} ·</ng-container>
                                    {{person?.resumen?.monto_adeudado_vencido | currency:'USD':'symbol':'1.2-2'}}
                                </span>
                                <span *ngIf="person?.resumen?.dias_morosidad_sin_historico >= 46 && person?.resumen?.dias_morosidad_sin_historico <= 60"
                                      class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-orange-100 text-orange-800 border border-orange-300">
                                    <i class="fas fa-circle-exclamation text-orange-600"></i>
                                    {{person?.resumen?.dias_morosidad_sin_historico}}d en mora ·
                                    <ng-container *ngIf="person?.resumen?.cuotas_morosas_count > 0">{{person?.resumen?.cuotas_morosas_count}} cuota{{person?.resumen?.cuotas_morosas_count > 1 ? 's' : ''}} ·</ng-container>
                                    {{person?.resumen?.monto_adeudado_vencido | currency:'USD':'symbol':'1.2-2'}}
                                </span>
                                <span *ngIf="person?.resumen?.dias_morosidad_sin_historico >= 61"
                                      class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-red-100 text-red-800 border border-red-300">
                                    <i class="fas fa-circle-exclamation text-red-600"></i>
                                    {{person?.resumen?.dias_morosidad_sin_historico}}d en mora ·
                                    <ng-container *ngIf="person?.resumen?.cuotas_morosas_count > 0">{{person?.resumen?.cuotas_morosas_count}} cuota{{person?.resumen?.cuotas_morosas_count > 1 ? 's' : ''}} ·</ng-container>
                                    {{person?.resumen?.monto_adeudado_vencido | currency:'USD':'symbol':'1.2-2'}}
                                </span>
                            </ng-container>
                            <span *ngIf="person?.resumen?.dias_morosidad_sin_historico <= 0"
                                  class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-green-100 text-green-800 border border-green-300">
                                <i class="fas fa-circle-check text-green-600"></i>
                                Al día
                            </span>

                            <!-- Estado cupo (derecha) -->
                            <span *ngIf="person?.person?.quota_active"
                                  class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-green-50 text-green-700 border border-green-200">
                                <i class="fas fa-circle-check text-green-600"></i>
                                Cupo activo
                            </span>
                        </div>

                        <!-- LÍNEA 2: KPIs ─ fees C001 · fees C004 · próxima cuota ----- -->
                        <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-700 mb-1.5">
                            <!-- Recargo C004 (reactivación) - solo si tiene -->
                            <span *ngIf="person?.resumen?.tiene_fee_reactivacion"
                                  class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-purple-50 text-purple-700 border border-purple-200">
                                <i class="fas fa-redo text-purple-500"></i>
                                <strong>Reactivación:</strong>
                                {{person?.resumen?.fees_c004_pendientes_count}} × {{person?.resumen?.fees_c004_pendientes_monto | currency:'USD':'symbol':'1.2-2'}}
                            </span>

                            <!-- Cuota prioritaria: cuando el cliente tiene mora muestra la cuota más
                                 vieja vencida (foco de cobranza, en rojo). Cuando está al día muestra
                                 la próxima futura a vencer (planificación). Fallback a proxima_cuota
                                 si el backend aún no envía cuota_prioritaria (datos pre-recálculo). -->
                            <!-- Variante 1: cuota prioritaria + vencida -->
                            <span *ngIf="person?.resumen?.cuota_prioritaria?.scheduledPaymentDate && person?.resumen?.cuota_prioritaria?.is_overdue"
                                  class="inline-flex items-center gap-1 ml-auto text-red-700 font-medium">
                                <i class="fas fa-exclamation-circle text-red-500"></i>
                                Vencida hace {{person?.resumen?.cuota_prioritaria?.debtor_days_count}}d ·
                                {{person?.resumen?.cuota_prioritaria?.scheduledPaymentDate | date:'dd MMM yyyy'}}
                                <span class="font-semibold">
                                    {{person?.resumen?.cuota_prioritaria?.amount | currency:'USD':'symbol':'1.2-2'}}
                                </span>
                            </span>
                            <!-- Variante 2: cuota prioritaria + no vencida (cliente al día) -->
                            <span *ngIf="person?.resumen?.cuota_prioritaria?.scheduledPaymentDate && !person?.resumen?.cuota_prioritaria?.is_overdue"
                                  class="inline-flex items-center gap-1 ml-auto text-gray-600">
                                <i class="fas fa-calendar text-blue-500"></i>
                                Próxima:
                                {{person?.resumen?.cuota_prioritaria?.scheduledPaymentDate | date:'dd MMM yyyy'}}
                                <span class="font-semibold">
                                    {{person?.resumen?.cuota_prioritaria?.amount | currency:'USD':'symbol':'1.2-2'}}
                                </span>
                            </span>
                            <!-- Variante 3 (fallback): backend aún no envía cuota_prioritaria -->
                            <span *ngIf="!person?.resumen?.cuota_prioritaria?.scheduledPaymentDate && person?.resumen?.proxima_cuota?.scheduledPaymentDate"
                                  class="inline-flex items-center gap-1 ml-auto text-gray-600">
                                <i class="fas fa-calendar text-blue-500"></i>
                                Próxima:
                                {{person?.resumen?.proxima_cuota?.scheduledPaymentDate | date:'dd MMM yyyy'}}
                                <span class="font-semibold">
                                    {{person?.resumen?.proxima_cuota?.amount | currency:'USD':'symbol':'1.2-2'}}
                                </span>
                            </span>
                        </div>

                        <!-- LÍNEA 3: histórico · tendencia · CTA --------------------- -->
                        <div class="flex flex-wrap items-center justify-between gap-2 text-xs text-gray-500">
                            <div>
                                <span *ngIf="person?.resumen?.dias_morosidad > 0"
                                      title="Mayor cantidad de días de mora que el cliente ha alcanzado en su historia (incluye cuotas ya pagadas)">
                                    Morosidad máxima histórica: <strong class="text-gray-700">{{person?.resumen?.dias_morosidad}}d</strong><span
                                          *ngIf="getReactivationEffectiveMora(person?.person) !== null"
                                          title="Mora recontada desde la última reactivación (la que usa la validación de reactivación)">
                                        · <strong class="text-amber-700">{{ getReactivationEffectiveMora(person?.person) }}d de mora desde reactivación</strong></span>
                                </span>
                            </div>
                            <div class="flex items-center gap-3">
                                <!-- Botón: recalcular mora manualmente para casos sospechosos -->
                                <a *ngIf="!_auth.hasRbac$.getValue() || _auth.hasPermission('contactos.vista_morosidad.ver_detalle')"
                                   class="inline-flex items-center gap-1 text-gray-500 hover:text-blue-600 font-medium cursor-pointer text-xs"
                                   [class.pointer-events-none]="isRefreshingMora"
                                   [class.opacity-60]="isRefreshingMora"
                                   (click)="refreshMoraManual()"
                                   title="Recalcular indicadores de mora del cliente (úsalo si sospechas que están desactualizados)">
                                    <i class="fas fa-rotate text-[10px]" [class.fa-spin]="isRefreshingMora"></i>
                                    {{ isRefreshingMora ? 'Recalculando…' : 'Recalcular' }}
                                </a>
                                <!-- CTA Ver detalle: abre modal con cuotas en mora + fees -->
                                <a *ngIf="!_auth.hasRbac$.getValue() || _auth.hasPermission('contactos.vista_morosidad.ver_detalle')"
                                   class="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 font-medium cursor-pointer text-xs"
                                   (click)="verDetalleCredito(creditDetail)">
                                    Ver detalle
                                    <i class="fas fa-arrow-right text-[10px]"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                        <!-- 🏛️ CARD: Domiciliaciones Bancarias -->
                        <div class="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden mt-2">
                            <!-- Header del Card (colapsable, cerrado por defecto) -->
                            <div class="bg-blue-50 border-gray-200 px-3 py-2 flex items-center gap-2"
                                 [class.border-b]="showDirectDebitSection">
                                <button type="button"
                                        class="flex items-center flex-wrap gap-2 flex-grow-1 bg-transparent border-0 cursor-pointer text-left p-0"
                                        [title]="showDirectDebitSection ? 'Ocultar domiciliaciones' : 'Ver domiciliaciones'"
                                        (click)="toggleDirectDebitSection()">
                                    <i class="fas fa-university text-blue-600 text-sm"></i>
                                    <h3 class="text-gray-800 font-bold text-sm m-0">Domiciliaciones Bancarias</h3>

                                    <!-- Resumen rápido cuando está colapsado -->
                                    <span *ngIf="!showDirectDebitSection" class="inline-flex items-center flex-wrap gap-1.5">
                                        <span *ngIf="hasActiveDirectDebit"
                                              class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-blue-100 text-blue-800">
                                            <i class="fas fa-check-circle"></i>
                                            {{ activeDirectDebitCount }} {{ activeDirectDebitCount === 1 ? 'cuenta domiciliada' : 'cuentas domiciliadas' }}
                                        </span>
                                        <span *ngIf="!hasActiveDirectDebit"
                                              class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-gray-100 text-gray-600">
                                            <i class="fas fa-university"></i>
                                            Sin domiciliación
                                        </span>
                                        <span *ngIf="deactivatedDirectDebitCount > 0"
                                              class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-amber-100 text-amber-800">
                                            <i class="fas fa-ban"></i>
                                            {{ deactivatedDirectDebitCount }} desactivada{{ deactivatedDirectDebitCount === 1 ? '' : 's' }}
                                        </span>
                                    </span>

                                    <i class="fas ms-auto text-gray-400"
                                       [ngClass]="showDirectDebitSection ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                </button>
                                <button type="button"
                                        *ngIf="showDirectDebitSection"
                                        class="inline-flex items-center gap-1 text-xs text-blue-700 hover:text-blue-900 bg-transparent border-0 cursor-pointer"
                                        title="Ver cuentas bancarias del cliente"
                                        (click)="openPaymentMethodsReadOnly()">
                                    <i class="fas fa-eye"></i>
                                    <span>Ver cuentas</span>
                                </button>
                            </div>

                            <!-- Body del Card -->
                            <div class="p-3" *ngIf="showDirectDebitSection">
                                <!-- Caso 1: Tiene domiciliaciones multi-producto -->
                                <ng-container *ngIf="person?.person?.product_direct_debit_afiliations && person?.person?.product_direct_debit_afiliations.length > 0">
                                    <ng-container *ngFor="let affiliation of person?.person?.product_direct_debit_afiliations; let last = last">
                                        <div *ngIf="affiliation?.is_active"
                                             class="flex items-start gap-2 bg-blue-50 border border-blue-200 rounded-md p-2"
                                             [class.mb-2]="!last">
                                            <i class="fas fa-check-circle text-blue-600 text-sm mt-0.5"></i>
                                            <div class="flex-grow-1">
                                                <div class="text-gray-800 font-bold text-xs">
                                                    {{getProductName(affiliation?.product_type)}}
                                                </div>
                                                <div class="text-gray-600 text-xs mt-0.5">
                                                    Domiciliado en {{affiliation?.afiliation?.bank?.name}}
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <!-- Caso 2: Solo tiene domiciliación legacy (CREDIT) -->
                                <div *ngIf="person?.person?.direct_debit_afiliation && (!person?.person?.product_direct_debit_afiliations || person?.person?.product_direct_debit_afiliations.length === 0)"
                                     class="flex items-start gap-2 bg-blue-50 border border-blue-200 rounded-md p-2">
                                    <i class="fas fa-check-circle text-blue-600 text-sm mt-0.5"></i>
                                    <div class="flex-grow-1">
                                        <div class="text-gray-800 font-bold text-xs">
                                            Crédito
                                        </div>
                                        <div class="text-gray-600 text-xs mt-0.5">
                                            Domiciliado en {{person?.person?.direct_debit_afiliation?.bank?.name}}
                                        </div>
                                    </div>
                                </div>

                                <!-- Caso 3: Sin domiciliación - Empty State -->
                                <div *ngIf="!person?.person?.direct_debit_afiliation && (!person?.person?.product_direct_debit_afiliations || person?.person?.product_direct_debit_afiliations.length === 0)"
                                     class="flex items-center gap-3 bg-blue-50 border border-blue-100 rounded-md p-3 text-center">
                                    <div class="bg-blue-100 rounded-full p-2 flex-shrink-0">
                                        <i class="fas fa-university text-blue-400 text-lg"></i>
                                    </div>
                                    <div class="text-left flex-grow-1">
                                        <p class="text-gray-800 font-semibold text-xs mb-0.5">
                                            Sin Domiciliación Bancaria
                                        </p>
                                        <p class="text-gray-600 text-xs">
                                            El cliente no tiene débito automático configurado
                                        </p>
                                    </div>
                                </div>

                                <!-- 🕐 Domiciliaciones Desactivadas (historial) -->
                                <div *ngIf="person?.deactivation_history && person?.deactivation_history.length > 0"
                                     class="mt-3 pt-3 border-t border-gray-200">
                                    <div class="flex items-center gap-2 mb-2">
                                        <i class="fas fa-history text-amber-600 text-xs"></i>
                                        <h4 class="text-gray-700 font-semibold text-xs uppercase tracking-wide m-0">
                                            Domiciliaciones Desactivadas
                                        </h4>
                                        <span class="ms-auto inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold bg-amber-100 text-amber-800">
                                            {{ person?.deactivation_history.length }}
                                        </span>
                                    </div>
                                    <div class="space-y-2">
                                        <div *ngFor="let d of person?.deactivation_history"
                                             class="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-md p-2">
                                            <i class="fas fa-ban text-amber-600 text-sm mt-0.5"></i>
                                            <div class="flex-grow-1">
                                                <div class="text-gray-800 font-bold text-xs">
                                                    {{ getProductName(d?.product_type) || d?.product_type || 'Crédito' }}
                                                    <span *ngIf="d?.bank_name && d?.bank_name !== 'N/A'" class="text-gray-600 font-normal">
                                                        · {{ d?.bank_name }}
                                                    </span>
                                                </div>
                                                <div class="text-gray-600 text-xs mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5">
                                                    <span>
                                                        Desactivada el <strong class="text-gray-800">{{ d?.deactivated_at | date: 'dd/MM/yyyy' }}</strong>
                                                    </span>
                                                    <span *ngIf="d?.days_mora != null">
                                                        · mora al momento: <strong class="text-amber-700">{{ d?.days_mora }}d</strong>
                                                    </span>
                                                </div>
                                                <div *ngIf="d?.account_number && d?.account_number !== 'N/A'"
                                                     class="text-gray-500 text-[11px] mt-0.5">
                                                    Cuenta ····{{ (d?.account_number || '').toString().slice(-4) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>

        <!-- Alerts Section -->
        <ng-container *ngIf="!loading && person?.person">
            <div *ngIf="!clientAprov" class="flex items-center gap-3 bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
                <i class="fas fa-exclamation-triangle text-yellow-600"></i>
                <span class="text-yellow-800 text-sm">Por favor complete el Onboarding del cliente</span>
            </div>

            <div *ngIf="direct_debit_customer.length>0" class="flex items-center gap-3 bg-red-50 border border-red-200 rounded-lg p-3 mb-6">
                <i class="fas fa-exclamation-triangle text-red-600"></i>
                <span class="text-red-800 text-sm">El cliente posee un cobro por domiciliación en proceso, por favor no realice ningún pago para evitar duplicidad de cobros.</span>
            </div>

            <!-- ══════════════ REWARDS WIDGET ══════════════ -->
            <app-rewards-card [personCode]="person?.person?.code"></app-rewards-card>
            <!-- ═════════════════════════════════════════════ -->

            <!-- Lista de Opciones -->
            <div class="space-y-3">
                <ng-container *ngFor="let option of profileOptions">
                    <ng-container *ngIf="shouldShowOption(option)">
                        <div (click)="handleOptionClick(option)"
                             [class]="'block bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400' + (option.id === 'quota' && loadQuota ? ' opacity-50 cursor-not-allowed' : '')">
                            <div class="flex items-center p-4">
                                <div class="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center mr-4" [ngClass]="option.color">
                                    <i [class]="option.icon + ' text-2xl'"></i>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <h3 class="text-lg font-semibold text-gray-900">
                                        {{ option.title }}
                                        <span *ngIf="option.id === 'quota' && loadQuota" class="text-sm font-normal">...</span>
                                    </h3>
                                    <p class="text-sm text-gray-600">{{ option.description }}</p>
                                </div>
                                <div class="flex-shrink-0 ml-4">
                                    <i class="fas fa-chevron-right text-gray-400"></i>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <!-- ============================================ -->
            <!-- PRODUCTOS COMPRADOS POR EL CLIENTE -->
            <!-- ============================================ -->
            <div class="mt-6 bg-white rounded-lg shadow-sm border border-gray-200"
                 *ngIf="!_auth.hasRbac$.getValue() ? _auth.IsPermitid(['OWNER','ANALIST','EJECUTIVE']) : _auth.hasPermission('contactos.productos_comprados.read')">
                <div class="p-4 border-b border-gray-200">
                    <button (click)="toggleCustomerProducts()"
                            class="w-full flex items-center justify-between text-left">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
                                <i class="fas fa-shopping-bag text-indigo-600 text-lg"></i>
                            </div>
                            <div>
                                <div class="font-semibold text-gray-900">Productos Comprados</div>
                                <div class="text-sm text-gray-500">Historial de productos adquiridos por el cliente</div>
                            </div>
                        </div>
                        <i class="fas text-gray-400" [ngClass]="showCustomerProducts ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                </div>

                <div *ngIf="showCustomerProducts" class="p-4 space-y-4">

                    <!-- Loading -->
                    <div *ngIf="loadingCustomerProducts" class="text-center py-8">
                        <i class="fas fa-spinner fa-spin text-3xl text-indigo-600"></i>
                        <div class="text-sm text-gray-600 mt-2">Cargando productos...</div>
                    </div>

                    <!-- Empty -->
                    <div *ngIf="!loadingCustomerProducts && customerProducts.length === 0" class="text-center py-8">
                        <i class="fas fa-box-open text-4xl text-gray-300 mb-3"></i>
                        <div class="text-sm text-gray-500">Este cliente aún no tiene compras registradas</div>
                    </div>

                    <!-- Data -->
                    <ng-container *ngIf="!loadingCustomerProducts && customerProducts.length > 0">

                        <!-- Summary KPIs -->
                        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3" *ngIf="customerProductsSummary">
                            <div class="bg-indigo-50 rounded-lg p-3 text-center border border-indigo-100">
                                <p class="text-[10px] font-medium text-indigo-600 uppercase mb-0.5">Compras</p>
                                <p class="text-lg font-bold text-indigo-900">{{customerProductsSummary.total_orders}}</p>
                            </div>
                            <div class="bg-green-50 rounded-lg p-3 text-center border border-green-100">
                                <p class="text-[10px] font-medium text-green-600 uppercase mb-0.5">Productos</p>
                                <p class="text-lg font-bold text-green-900">{{customerProductsSummary.total_products}}</p>
                            </div>
                            <div class="bg-blue-50 rounded-lg p-3 text-center border border-blue-100">
                                <p class="text-[10px] font-medium text-blue-600 uppercase mb-0.5">Monto Total</p>
                                <p class="text-lg font-bold text-blue-900">${{formatCurrencyValue(customerProductsSummary.total_amount)}}</p>
                            </div>
                            <div class="bg-purple-50 rounded-lg p-3 text-center border border-purple-100">
                                <p class="text-[10px] font-medium text-purple-600 uppercase mb-0.5">Última Compra</p>
                                <p class="text-sm font-bold text-purple-900">{{formatShortDate(customerProductsSummary.last_purchase)}}</p>
                            </div>
                        </div>

                        <!-- Currency breakdown -->
                        <div *ngIf="customerProductsCurrency.length > 0" class="flex flex-wrap gap-3">
                            <div *ngFor="let curr of customerProductsCurrency"
                                 class="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
                                <span class="text-xs font-bold text-gray-700">{{curr.currency}}</span>
                                <span class="text-xs text-gray-500">{{curr.count}} compras</span>
                                <span class="text-xs font-semibold text-green-700">${{formatCurrencyValue(curr.total_amount)}}</span>
                                <span *ngIf="curr.avg_rate" class="text-[10px] text-gray-400">(Tasa: {{formatCurrencyValue(curr.avg_rate)}})</span>
                            </div>
                        </div>

                        <!-- Products Table -->
                        <div class="overflow-x-auto border border-gray-200 rounded-lg">
                            <table class="w-full">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th class="px-3 py-2.5 text-left text-xs font-semibold text-gray-600 uppercase">Producto</th>
                                        <th class="px-3 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">Compras</th>
                                        <th class="px-3 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">Uds.</th>
                                        <th class="px-3 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">Monto</th>
                                        <th class="px-3 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase hidden sm:table-cell">Precio Prom.</th>
                                        <th class="px-3 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase hidden sm:table-cell">Última</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-200">
                                    <tr *ngFor="let p of customerProducts; let i = index" class="hover:bg-gray-50">
                                        <td class="px-3 py-2.5">
                                            <div class="flex items-center gap-2">
                                                <span class="inline-flex items-center justify-center w-6 h-6 rounded-full text-[10px] font-bold"
                                                      [ngClass]="i < 3 ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-500'">
                                                    {{i + 1}}
                                                </span>
                                                <div class="min-w-0">
                                                    <p class="text-sm font-medium text-gray-900 truncate max-w-[200px]">{{p.name}}</p>
                                                    <p class="text-[10px] text-gray-400 font-mono">{{p.code}}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-3 py-2.5 text-right text-sm font-mono text-gray-700">{{p.total_purchases}}</td>
                                        <td class="px-3 py-2.5 text-right text-sm font-mono font-semibold text-gray-900">{{p.total_units}}</td>
                                        <td class="px-3 py-2.5 text-right text-sm font-mono font-semibold text-green-700">${{formatCurrencyValue(p.total_amount)}}</td>
                                        <td class="px-3 py-2.5 text-right text-sm font-mono text-gray-600 hidden sm:table-cell">${{formatCurrencyValue(p.avg_price)}}</td>
                                        <td class="px-3 py-2.5 text-right text-xs text-gray-500 hidden sm:table-cell">{{formatShortDate(p.last_purchase)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- Error State -->
        <div *ngIf="!loading && !person?.person" class="text-center py-12">
            <i class="fas fa-user-slash text-4xl text-gray-400 mb-4"></i>
            <h3 class="text-xl font-bold text-gray-900 mb-2">Usuario no encontrado</h3>
            <p class="text-gray-600 text-sm">No se encontró persona con este ID: {{queryParams?.code}}</p>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="text-center py-12">
            <div class="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mb-4"></div>
            <p class="text-gray-600 text-sm">Cargando información del perfil...</p>
        </div>
    </div>
</div>

<!-- Mantener ng-template payment sin cambios -->
<ng-template #payment let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-10 offset-md-1 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                               Detalle de Pago
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">
            <div class="row">
                <div class=" col-12 col-md-10 offset-md-1">
                    <div class="text-start">
                        <app-person-payments [code_person]="params_payment['person_code']" [code_payment]="params_payment['code_payment']" (resetStatus)="response($event)"></app-person-payments>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- ════════════════════════════════════════════════════════════════ -->
<!-- Modal: Detalle de crédito del cliente (Ajuste 06)                -->
<!-- ════════════════════════════════════════════════════════════════ -->
<ng-template #creditDetail let-offcanvas>
    <div class="offcanvas-header border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <div>
            <h5 class="text-lg font-bold text-gray-900 m-0">Detalle de Crédito</h5>
            <p class="text-xs text-gray-500 m-0">
                {{person?.person?.name}} {{person?.person?.lastName}} · {{getIdentity(person)}}
            </p>
        </div>
    </div>

    <div class="offcanvas-body offcanvas-body--credit-detail p-4 space-y-5 overflow-y-auto">

        <!-- ═════ Resumen consolidado — estilo planilla contable ═════ -->
        <div id="creditCaptureContainer" class="bg-white p-2">
            <!-- Encabezado: cliente + tasa Bs/$ -->
            <div class="flex justify-between items-center mb-3 pb-2 border-b border-gray-200">
                <div class="text-xs text-gray-600">
                    <div class="font-semibold text-gray-800">{{person?.person?.name}} {{person?.person?.lastName}}</div>
                    <div class="text-gray-500">{{getIdentity(person)}}</div>
                </div>
                <div class="text-right text-xs">
                    <ng-container *ngIf="creditRateAvailable; else rateNA">
                        <div class="text-gray-500">Tasa</div>
                        <div class="font-semibold text-gray-900">{{creditRate | number:'1.2-2':'es-VE'}} Bs/$</div>
                    </ng-container>
                    <ng-template #rateNA>
                        <span class="text-gray-400 italic">
                            <ng-container *ngIf="loadingCreditRate; else rateMissing">Cargando tasa…</ng-container>
                            <ng-template #rateMissing>Tasa no disponible</ng-template>
                        </span>
                    </ng-template>
                </div>
            </div>

            <!-- Fila 1: Mora actual + Total de la deuda -->
            <div class="grid grid-cols-2 gap-3 mb-3">
                <div class="border border-gray-200 rounded-lg p-4">
                    <div class="text-[11px] text-gray-500 uppercase tracking-wide font-semibold">Mora actual</div>
                    <div class="text-3xl font-bold text-gray-900 mt-2 leading-none">
                        {{person?.resumen?.dias_morosidad_sin_historico || 0}}<span class="text-base text-gray-500 font-normal"> días</span>
                    </div>
                </div>
                <div class="border border-gray-200 rounded-lg p-4">
                    <div class="text-[11px] text-gray-500 uppercase tracking-wide font-semibold">Total de la deuda</div>
                    <div class="text-2xl font-bold text-gray-900 mt-2 leading-none">
                        {{totalDeudaUsd() | currency:'USD':'symbol':'1.2-2'}}
                    </div>
                    <div class="text-xs text-gray-500 mt-1">
                        <ng-container *ngIf="toBs(totalDeudaUsd()) as bs; else noBsTotal">
                            Bs. {{bs | number:'1.2-2':'es-VE'}}
                        </ng-container>
                        <ng-template #noBsTotal><span class="text-gray-400">Bs. —</span></ng-template>
                    </div>
                </div>
            </div>

            <!-- Filas apiladas (full-width): Cuotas vencidas, Penalidad por incumplimiento, Penalidad por reactivación -->
            <div class="space-y-3">
                <!-- Cuotas vencidas -->
                <div class="border border-gray-200 rounded-lg p-4">
                    <div class="flex items-start justify-between">
                        <div>
                            <div class="text-[11px] text-gray-500 uppercase tracking-wide font-semibold">Cuotas vencidas</div>
                            <div class="text-xs text-gray-600 mt-1">
                                {{person?.resumen?.cuotas_morosas_count || 0}} cuota<ng-container *ngIf="(person?.resumen?.cuotas_morosas_count || 0) !== 1">s</ng-container> vencida<ng-container *ngIf="(person?.resumen?.cuotas_morosas_count || 0) !== 1">s</ng-container>
                            </div>
                        </div>
                        <div class="text-right">
                            <div class="text-xl font-bold text-gray-900 leading-none">
                                {{(person?.resumen?.monto_adeudado_vencido || 0) | currency:'USD':'symbol':'1.2-2'}}
                            </div>
                            <div class="text-xs text-gray-500 mt-1">
                                <ng-container *ngIf="toBs(person?.resumen?.monto_adeudado_vencido) as bs; else noBsCuotas">
                                    Bs. {{bs | number:'1.2-2':'es-VE'}}
                                </ng-container>
                                <ng-template #noBsCuotas><span class="text-gray-400">Bs. —</span></ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Penalidad por incumplimiento -->
                <div class="border border-gray-200 rounded-lg p-4">
                    <div class="flex items-start justify-between">
                        <div>
                            <div class="text-[11px] text-gray-500 uppercase tracking-wide font-semibold">Penalidad por incumplimiento</div>
                            <div class="text-xs text-gray-600 mt-1">
                                {{person?.resumen?.fees_c001_pendientes_count || 0}} fee<ng-container *ngIf="(person?.resumen?.fees_c001_pendientes_count || 0) !== 1">s</ng-container> vencido<ng-container *ngIf="(person?.resumen?.fees_c001_pendientes_count || 0) !== 1">s</ng-container>
                            </div>
                        </div>
                        <div class="text-right">
                            <div class="text-xl font-bold text-gray-900 leading-none">
                                {{(person?.resumen?.fees_c001_pendientes_monto || 0) | currency:'USD':'symbol':'1.2-2'}}
                            </div>
                            <div class="text-xs text-gray-500 mt-1">
                                <ng-container *ngIf="toBs(person?.resumen?.fees_c001_pendientes_monto) as bs; else noBsIncumplimiento">
                                    Bs. {{bs | number:'1.2-2':'es-VE'}}
                                </ng-container>
                                <ng-template #noBsIncumplimiento><span class="text-gray-400">Bs. —</span></ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Penalidad por reactivación (solo si tiene y no estamos en captura) -->
                <div *ngIf="(person?.resumen?.fees_c004_pendientes_count || 0) > 0 && !hideC004ForCapture"
                     class="border border-gray-200 rounded-lg p-4">
                    <div class="flex items-start justify-between">
                        <div>
                            <div class="text-[11px] text-gray-500 uppercase tracking-wide font-semibold">Penalidad por reactivación</div>
                            <div class="text-xs text-gray-600 mt-1">
                                {{person?.resumen?.fees_c004_pendientes_count}} fee<ng-container *ngIf="person?.resumen?.fees_c004_pendientes_count !== 1">s</ng-container> de reactivación
                            </div>
                        </div>
                        <div class="text-right">
                            <div class="text-xl font-bold text-gray-900 leading-none">
                                {{person?.resumen?.fees_c004_pendientes_monto | currency:'USD':'symbol':'1.2-2'}}
                            </div>
                            <div class="text-xs text-gray-500 mt-1">
                                <ng-container *ngIf="toBs(person?.resumen?.fees_c004_pendientes_monto) as bs; else noBsReactivacion">
                                    Bs. {{bs | number:'1.2-2':'es-VE'}}
                                </ng-container>
                                <ng-template #noBsReactivacion><span class="text-gray-400">Bs. —</span></ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>

    <div class="offcanvas-footer border-t border-gray-200 p-3 flex items-center justify-between gap-2">
        <button type="button"
                class="px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-semibold inline-flex items-center gap-1 border-0 cursor-pointer"
                title="Descargar imagen del detalle"
                [disabled]="downloadingCreditCapture"
                (click)="descargarDetalleCredito()">
            <i class="fas" [ngClass]="downloadingCreditCapture ? 'fa-spinner fa-spin' : 'fa-arrow-down'"></i>
            <span>{{downloadingCreditCapture ? 'Generando…' : 'Descargar'}}</span>
        </button>
        <div class="flex items-center gap-2">
            <a *ngIf="!_auth.hasRbac$.getValue() || _auth.hasPermission('contactos.vista_morosidad.ver_detalle_completo')"
               [routerLink]="['/console/cliente', person?.person?.code]"
               (click)="offcanvas.dismiss()"
               class="px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold no-underline inline-flex items-center gap-1"
               title="Abrir perfil completo del cliente">
                Ver detalle completo →
            </a>
            <button type="button" class="px-3 py-1.5 rounded-md border border-gray-300 hover:bg-gray-50 text-gray-700 text-xs font-semibold bg-white cursor-pointer"
                    (click)="offcanvas.dismiss()">
                Cerrar
            </button>
        </div>
    </div>
</ng-template>

<!-- 💳 Drawer: cuentas bancarias del cliente (solo lectura) -->
<ng-template #paymentMethodsDrawer let-offcanvas>
    <div class="offcanvas-header border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <div>
            <h5 class="text-lg font-bold text-gray-900 m-0">
                <i class="fas fa-university text-blue-600 me-2"></i>
                Cuentas Bancarias
            </h5>
            <p class="text-xs text-gray-500 m-0">
                {{ person?.person?.name }} {{ person?.person?.lastName }} · {{ getIdentity(person) }}
            </p>
            <p class="text-xs text-gray-500 m-0 mt-1">
                Vista de solo lectura. Para registrar o editar cuentas, ir al Onboarding del cliente.
            </p>
        </div>
        <button type="button"
                class="text-2xl leading-none text-gray-400 hover:text-gray-700 bg-transparent border-0 p-0 cursor-pointer"
                aria-label="Cerrar"
                (click)="offcanvas.dismiss()">
            <i class="fas fa-times"></i>
        </button>
    </div>
    <div class="offcanvas-body p-3 overflow-y-auto">
        <app-payment-method
            [code_person]="person?.person?.code"
            [estatus_approve]="true"
            [readOnly]="true">
        </app-payment-method>
    </div>
</ng-template>
